"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../types/EventType");
var CountryIsoCode_1 = require("../types/CountryIsoCode");
var Id_1 = require("../types/Id");
var Latitude_1 = require("../types/Latitude");
var Longitude_1 = require("../types/Longitude");
var AbstractEvent_1 = require("./AbstractEvent");
var HomeSearchQuery = (function () {
    function HomeSearchQuery(id, query) {
        this.id = id;
        this.sort_type = HomeSearchSortType.Relevance;
        this.sort_type = HomeSearchQuery.sortTypeFromQuery(query);
        this.filters = HomeSearchFilters.fromQuery(query);
    }
    HomeSearchQuery.sortTypeFromQuery = function (query) {
        return (query.sort && query.sort.type) || HomeSearchSortType.Relevance;
    };
    return HomeSearchQuery;
}());
var HomeSearchSortType;
(function (HomeSearchSortType) {
    HomeSearchSortType["Relevance"] = "relevance";
    HomeSearchSortType["MostExchanged"] = "most_exchanged";
    HomeSearchSortType["Newest"] = "newest";
    HomeSearchSortType["MostResponsive"] = "most_responsive";
    HomeSearchSortType["MostRecentAvailabilities"] = "most_recent_availabilities";
})(HomeSearchSortType || (HomeSearchSortType = {}));
var HomeSearchFilters = (function () {
    function HomeSearchFilters(amenities, availability, bathrooms_count, bedrooms_count, beds_count, capacity, guest_beds, guestpoints_per_night, home_type, is_extended, location, only_home_with_picture, only_primary_residence, only_verified_home, preferred_destination, response_rate_above_threshold, reverse_search, user_groups, collection) {
        this.amenities = amenities;
        this.availability = availability;
        this.bathrooms_count = bathrooms_count;
        this.bedrooms_count = bedrooms_count;
        this.beds_count = beds_count;
        this.capacity = capacity;
        this.guest_beds = guest_beds;
        this.guestpoints_per_night = guestpoints_per_night;
        this.home_type = home_type;
        this.is_extended = is_extended;
        this.location = location;
        this.only_home_with_picture = only_home_with_picture;
        this.only_primary_residence = only_primary_residence;
        this.only_verified_home = only_verified_home;
        this.preferred_destination = preferred_destination;
        this.response_rate_above_threshold = response_rate_above_threshold;
        this.reverse_search = reverse_search;
        this.user_groups = user_groups;
        this.collection = collection;
    }
    HomeSearchFilters.fromQuery = function (query) {
        return new HomeSearchFilters(AmenitiesFilterParams.fromQuery(query), AvailabilityFilterParams.fromQuery(query), BathroomsCountFilterParams.fromQuery(query), BedroomsCountFilterParams.fromQuery(query), BedsCountFilterParams.fromQuery(query), CapacityFilterParams.fromQuery(query), HomeSearchFilters.hasFilter(query, "no-bed-up"), GuestpointsPerNightFilterParams.fromQuery(query), HomeTypeFilterParams.fromQuery(query), query.extended, LocationFilterParams.fromQuery(query), HomeSearchFilters.hasFilter(query, "home-with-picture"), IsPrimaryResidenceFilterParams.fromQuery(query), HomeSearchFilters.hasFilter(query, "home-verified"), PreferredDestinationFilterParams.fromQuery(query), HomeSearchFilters.hasFilter(query, "response-rate-above-threshold"), HomeSearchFilters.hasFilter(query, "reverse-search"), UserGroupsFilterParams.fromQuery(query), CollectionFilterParams.fromQuery(query));
    };
    HomeSearchFilters.hasFilter = function (query, name) {
        return query.filter !== undefined && query.filter.indexOf(name) !== -1;
    };
    return HomeSearchFilters;
}());
var CollectionFilterParams = (function () {
    function CollectionFilterParams() {
    }
    CollectionFilterParams.fromQuery = function (query) {
        return query.collection;
    };
    return CollectionFilterParams;
}());
var IsPrimaryResidenceFilterParams = (function () {
    function IsPrimaryResidenceFilterParams() {
    }
    IsPrimaryResidenceFilterParams.fromQuery = function (query) {
        return query.home && query.home.is_primary;
    };
    return IsPrimaryResidenceFilterParams;
}());
var CapacityFilterParams = (function () {
    function CapacityFilterParams() {
    }
    CapacityFilterParams.fromQuery = function (query) {
        return query.guests_nb;
    };
    return CapacityFilterParams;
}());
var Amenities;
(function (Amenities) {
    Amenities["Garden"] = "garden";
    Amenities["SwimmingPool"] = "swimming-pool";
    Amenities["Playground"] = "playground";
    Amenities["BalconyTerrace"] = "balcony-terrace";
    Amenities["DisabledAccess"] = "disabled-access";
    Amenities["BabyGear"] = "baby-gear";
    Amenities["Dishwasher"] = "dishwasher";
    Amenities["Dryer"] = "dryer";
    Amenities["WashingMachine"] = "washing-machine";
    Amenities["Bathtub"] = "bathtub";
    Amenities["HeatingSystem"] = "heating-system";
    Amenities["TV"] = "tv";
    Amenities["Wifi"] = "wifi";
    Amenities["AC"] = "a-c";
    Amenities["Elevator"] = "elevator";
    Amenities["ParkingSpace"] = "parking-space";
    Amenities["Jacuzzi"] = "jacuzzi";
    Amenities["Fireplace"] = "fireplace";
    Amenities["Car"] = "car";
    Amenities["Doorman"] = "doorman";
    Amenities["CleaningPerson"] = "cleaning-person";
    Amenities["Cook"] = "cook";
    Amenities["SmokersWelcome"] = "smokers-welcome";
    Amenities["PetsWelcome"] = "pets-welcome";
    Amenities["ChildrenWelcome"] = "children-welcome";
})(Amenities || (Amenities = {}));
var AmenitiesFilterParams = (function () {
    function AmenitiesFilterParams() {
    }
    AmenitiesFilterParams.fromQuery = function (query) {
        return query.home && query.home.amenities;
    };
    return AmenitiesFilterParams;
}());
var GuestpointsPerNightFilterParams = (function () {
    function GuestpointsPerNightFilterParams(from, to) {
        this.from = from;
        this.to = to;
        if (from !== undefined && (from < 0 || from > 1000)) {
            throw new Error("From must be in inclusive range 0 to 1000");
        }
        if (to !== undefined && (to < 0 || to > 1000)) {
            throw new Error("To must be in inclusive range 0 to 1000");
        }
    }
    GuestpointsPerNightFilterParams.fromQuery = function (query) {
        return query.guestpoints && new GuestpointsPerNightFilterParams(query.guestpoints.from, query.guestpoints.to);
    };
    return GuestpointsPerNightFilterParams;
}());
var AvailabilityFlexibility;
(function (AvailabilityFlexibility) {
    AvailabilityFlexibility[AvailabilityFlexibility["One"] = 1] = "One";
    AvailabilityFlexibility[AvailabilityFlexibility["Three"] = 3] = "Three";
    AvailabilityFlexibility[AvailabilityFlexibility["Seven"] = 7] = "Seven";
})(AvailabilityFlexibility || (AvailabilityFlexibility = {}));
var AvailabilityDateRange = (function () {
    function AvailabilityDateRange(from, to, flexibility, minimum_nights_count) {
        this.from = from;
        this.to = to;
        this.flexibility = flexibility;
        this.minimum_nights_count = minimum_nights_count;
    }
    AvailabilityDateRange.fromQueryAvailabilityDateRange = function (queryAvailabilityDateRange) {
        return new AvailabilityDateRange(queryAvailabilityDateRange.from, queryAvailabilityDateRange.to, queryAvailabilityDateRange.flexibility, queryAvailabilityDateRange.minimum_nights_count);
    };
    return AvailabilityDateRange;
}());
var AvailabilityFilterParams = (function () {
    function AvailabilityFilterParams(date_range, reciprocal) {
        this.date_range = date_range;
        this.reciprocal = reciprocal;
    }
    AvailabilityFilterParams.fromQuery = function (query) {
        return query.availability && new AvailabilityFilterParams(query.availability.date_range && AvailabilityDateRange.fromQueryAvailabilityDateRange(query.availability.date_range), query.availability.reciprocal);
    };
    return AvailabilityFilterParams;
}());
var BathroomsCountFilterParams = (function () {
    function BathroomsCountFilterParams() {
    }
    BathroomsCountFilterParams.fromQuery = function (query) {
        var res;
        if (query.home !== undefined && query.home.size !== undefined && query.home.size.bathrooms !== undefined) {
            if (query.home.size.bathrooms < 0 || query.home.size.bathrooms > 10) {
                throw new Error("Bathrooms count must be in inclusive range 0 to 10");
            }
            res = query.home.size.bathrooms;
        }
        return res;
    };
    return BathroomsCountFilterParams;
}());
var BedroomsCountFilterParams = (function () {
    function BedroomsCountFilterParams() {
    }
    BedroomsCountFilterParams.fromQuery = function (query) {
        var res;
        if (query.home !== undefined && query.home.size !== undefined && query.home.size.bedrooms !== undefined) {
            if (query.home.size.bedrooms < 0 || query.home.size.bedrooms > 20) {
                throw new Error("Bedrooms count must be in inclusive range 0 to 20");
            }
            res = query.home.size.bedrooms;
        }
        return res;
    };
    return BedroomsCountFilterParams;
}());
var BedsCountFilterParams = (function () {
    function BedsCountFilterParams(adult_bed_count, child_bed_count, baby_bed_count) {
        this.adult_bed_count = adult_bed_count;
        this.child_bed_count = child_bed_count;
        this.baby_bed_count = baby_bed_count;
        if (adult_bed_count < 0 || adult_bed_count > 20) {
            throw new Error("Adult bed count must be in inclusive range 0 to 20");
        }
        if (child_bed_count < 0 || child_bed_count > 20) {
            throw new Error("Child bed count must be in inclusive range 0 to 20");
        }
        if (baby_bed_count < 0 || baby_bed_count > 20) {
            throw new Error("Baby bed count must be in inclusive range 0 to 20");
        }
    }
    BedsCountFilterParams.fromQuery = function (query) {
        return query.home && query.home.size && query.home.size.beds && new BedsCountFilterParams(query.home.size.beds.adults, query.home.size.beds.children, query.home.size.beds.babies);
    };
    return BedsCountFilterParams;
}());
var HomeType;
(function (HomeType) {
    HomeType["Home"] = "home";
    HomeType["Flat"] = "flat";
})(HomeType || (HomeType = {}));
var HomeTypeFilterParams = (function () {
    function HomeTypeFilterParams() {
    }
    HomeTypeFilterParams.fromQuery = function (query) {
        return query.home && query.home.type;
    };
    return HomeTypeFilterParams;
}());
var Bound = (function () {
    function Bound(lat, lon) {
        this.lat = lat;
        this.lon = lon;
    }
    Bound.fromQueryBound = function (bound) {
        return new Bound(new Latitude_1.Latitude(bound.lat), new Longitude_1.Longitude(bound.lon));
    };
    return Bound;
}());
var Bounds = (function () {
    function Bounds(ne, sw) {
        this.ne = ne;
        this.sw = sw;
    }
    Bounds.fromQueryBounds = function (queryBounds) {
        return new Bounds(Bound.fromQueryBound(queryBounds.ne), Bound.fromQueryBound(queryBounds.sw));
    };
    return Bounds;
}());
var Polygon = (function () {
    function Polygon(location_id) {
        this.location_id = location_id;
    }
    Polygon.fromQueryPolygon = function (polygonObj) {
        return new Polygon(polygonObj.location_id);
    };
    return Polygon;
}());
var LocationFilterParams = (function () {
    function LocationFilterParams(bounds, country, polygon) {
        this.bounds = bounds;
        this.country = country;
        this.polygon = polygon;
    }
    LocationFilterParams.fromQuery = function (query) {
        return query.location && new LocationFilterParams(query.location.bounds && Bounds.fromQueryBounds(query.location.bounds), query.location.country && new CountryIsoCode_1.CountryIsoCode(query.location.country), query.location.polygon && Polygon.fromQueryPolygon(query.location.polygon));
    };
    return LocationFilterParams;
}());
var AdminLevel;
(function (AdminLevel) {
    AdminLevel["Continent"] = "continent";
    AdminLevel["Country"] = "country";
    AdminLevel["State"] = "state";
    AdminLevel["County"] = "county";
    AdminLevel["City"] = "city";
    AdminLevel["District"] = "district";
})(AdminLevel || (AdminLevel = {}));
var PreferredDestinationFilterParams = (function () {
    function PreferredDestinationFilterParams(bounds, admin_level) {
        this.bounds = bounds;
        this.admin_level = admin_level;
    }
    PreferredDestinationFilterParams.fromQuery = function (query) {
        return query.preferred_destination && new PreferredDestinationFilterParams(Bounds.fromQueryBounds(query.preferred_destination.bounds), query.preferred_destination.admin_level);
    };
    return PreferredDestinationFilterParams;
}());
var UserGroupsFilterParams = (function () {
    function UserGroupsFilterParams() {
    }
    UserGroupsFilterParams.fromQuery = function (query) {
        return query.host && query.host.groups && query.host.groups.map(function (i) { return new Id_1.Id(i); });
    };
    return UserGroupsFilterParams;
}());
var HomesSearchedEvent = (function (_super) {
    __extends(HomesSearchedEvent, _super);
    function HomesSearchedEvent(id, query) {
        var _this = _super.call(this) || this;
        _this.props = new HomeSearchedEventProperties(new HomeSearchQuery(id, query));
        return _this;
    }
    HomesSearchedEvent.prototype.getType = function () {
        return EventType_1.EventType.HomesSearched;
    };
    return HomesSearchedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.HomesSearchedEvent = HomesSearchedEvent;
var HomeSearchedEventProperties = (function () {
    function HomeSearchedEventProperties(query) {
        this.query = query;
    }
    return HomeSearchedEventProperties;
}());
//# sourceMappingURL=HomesSearchedEvent.js.map